import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  GridItem,
  Input,
} from "@chakra-ui/react";
import React from "react";
import { Trans, useTranslation } from "react-i18next";

/**
 * Renders the caller form
 * 
 * @param {Function} register - The form registration function
 * @param {Object} errors - The form errors object
 * @returns The caller form
 */
const CallerForm = ({ register, errors }) => {
  const { t } = useTranslation();

  return (
    <Grid
      gap={"8px"}
      templateColumns={{ base: "repeat(1, 1fr)", xl: "repeat(5, 1fr)" }}
      templateRows={{ base: "repeat(1, 1fr)", xl: "repeat(2, 1fr)" }}
    >
      <GridItem colSpan={5} rowSpan={1}>
        <FormControl isInvalid={errors?.phoneNumber}>
          <FormLabel fontSize={12} htmlFor={"phoneNumber"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.phoneNumber.title</Trans>
          </FormLabel>
          <Input
            id={"phoneNumber"}
            placeholder={t("beneficiaryFile.form.phoneNumber.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("phoneNumber", {
              required: t("beneficiaryFile.form.phoneNumber.required"),
            })}
          />
          <FormErrorMessage fontSize={8}>
            {errors?.phoneNumber && errors?.phoneNumber?.message}
          </FormErrorMessage>
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"gender"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.gender.title</Trans>
          </FormLabel>
          <Input
            id={"gender"}
            placeholder={t("beneficiaryFile.form.gender.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("gender")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={2} rowSpan={1}>
        <FormControl isInvalid={errors?.lastName}>
          <FormLabel fontSize={12} htmlFor={"lastName"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.lastName.title</Trans>
          </FormLabel>
          <Input
            id={"lastName"}
            placeholder={t("beneficiaryFile.form.lastName.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("lastName", {
              required: t("beneficiaryFile.form.lastName.required"),
            })}
          />
          <FormErrorMessage fontSize={8}>
            {errors?.lastName && errors?.lastName?.message}
          </FormErrorMessage>
        </FormControl>
      </GridItem>
      <GridItem colSpan={2} rowSpan={1}>
        <FormControl isInvalid={errors?.firstName}>
          <FormLabel fontSize={12} htmlFor={"firstName"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.firstName.title</Trans>
          </FormLabel>
          <Input
            id={"firstName"}
            placeholder={t("beneficiaryFile.form.firstName.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("firstName", {
              required: t("beneficiaryFile.form.firstName.required"),
            })}
          />
          <FormErrorMessage fontSize={8}>
            {errors?.firstName && errors?.firstName?.message}
          </FormErrorMessage>
        </FormControl>
      </GridItem>
    </Grid>
  );
};

export default CallerForm;
